<template>
  <UButton :label="isAddingToCart ? 'Added To Cart!' : 'Add To Cart'" :size="size" icon="mdi:cart-plus"
    class="cursor-pointer" :loading="isAddingToCart" @click="clickAddToCart" />
</template>

<script setup lang="ts">
type Sizes = "md" | "xs" | "sm" | "lg" | "xl" | undefined
const { course, quantity, size = 'md' } = defineProps<{ course: CoursesRecord, quantity: number, size?: Sizes }>()

const { addToCart } = useCart()
const isAddingToCart = ref(false)

function clickAddToCart() {
  isAddingToCart.value = true
  addToCart(course, quantity)
  setTimeout(() => {
    isAddingToCart.value = false
  }, 1000)
}
</script>

<style scoped></style>
